
import { defineComponent, PropType } from "vue";
import { IPreschoolDimensionsModel } from "@/interfaces/modules";
import PreschoolDimensionsService from "@/api/Preschool/PreschoolDimensionsService";
import router from "@/router";
import store from "@/store";

export default defineComponent({
    name: "PreschoolAcademicCompetencyBasicDataTab",
    props: {
        dimension: {
            type: Object as PropType<IPreschoolDimensionsModel | null>,
            required: true,
        },
    },
    data() {
        return {
            dimensionId: 0,
            form: {
                loading: true,
                valid: false,
                wasValidated: false,
                record: {} as IPreschoolDimensionsModel,
                rules: {
                    required: [(v: any) => !!v || "Este campo es requerido"],
                },
            },
            loading: true,
            saving: false,
        };
    },
    computed: {
        formRecord(): any {
            return this.$refs.formRecord;
        },
    },
    async mounted() {
        if (this.dimension?.Id) {
            console.log(' entro', this.dimension.Id);
            this.form.record = await PreschoolDimensionsService.GetPreschoolDimensionById(this.dimension.Id as any);
        }
    },
    methods: {
        async save() {
            try {
                this.form.loading = true;
                const res = await PreschoolDimensionsService.PostPreschoolDimension(this.form.record);
                store.dispatch("core/popupDialog", {
                    text: "Registro completado con éxito.",
                    type: "success",
                    showCancelButton: false,
                });
                this.form.loading = false;
                router.push(`/base-academic/competencies-tab-content/${res.Id}`);
                location.reload();
            } catch (err: any) {
                this.form.loading = false;
                store.dispatch("core/popupDialog", {
                    text: `Error: ${err?.response?.data?.message || err?.message}`,
                    type: "error",
                    showCancelButton: false,
                });
            }
        },

        cancel(_file: any) {
            router.push({ name: "competencies" });
        },

    },
});
